import { render, staticRenderFns } from "./fileDetails.vue?vue&type=template&id=3e825faa&scoped=true&"
import script from "./fileDetails.vue?vue&type=script&lang=js&"
export * from "./fileDetails.vue?vue&type=script&lang=js&"
import style0 from "./fileDetails.vue?vue&type=style&index=0&id=3e825faa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e825faa",
  null
  
)

export default component.exports